import { filterObjectValues } from 'helpers/filter'

import { Mpost } from 'models/mpost'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api from '../api'
import { GetMpostListResponse, GetMpostParams } from './types'

export const mpostApi = api.injectEndpoints({
  endpoints: build => ({
    getMpostById: build.query<Mpost, Mpost['id']>({
      query: id => ({
        url: `/web/mpost/${id}/`,
      }),
    }),
    getMpost: build.query<GetMpostListResponse, GetMpostParams>({
      query: params => ({
        url: `/web/mpost/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    mpostStatistics: build.query<Array<IStatistic>, GetMpostParams>({
      query: params => ({
        url: `/web/mpost/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    downloadMpostExcel: build.mutation<void, GetMpostParams>({
      query: params => ({
        url: `/web/mpost/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
